/*
 * Modo "VER COMO" (01/10/2026): a TI enxerga o Central com o acesso de outro usuario (menu,
 * telas, permissoes), a partir de TI > Logins & Usuarios.
 *
 * Como funciona: o Central decide o que cada um ve NO NAVEGADOR, a partir do usuario da sessao
 * (setor/cargo/id -- lib/acessoTela.js, PermissionGate do App.jsx, Sidebar). O "ver como" troca
 * esse usuario pelo escolhido e guarda o da TI (GlobalVar: realUser) para voltar.
 *
 * ⚠️ E SO VISUALIZACAO. O backend nao tem sessao e confia no e-mail que a tela manda
 * (solicitante): qualquer gravacao feita nesse modo sairia EM NOME do outro usuario. Por isso,
 * enquanto o modo esta ativo, este guarda intercepta o fetch e bloqueia as rotas que gravam --
 * reconhecidas pelo VERBO no nome da rota (SalvarEvento, CriaUsuario, PromoFinalizar,
 * FilaAprovar...). Consultas passam. Na duvida o bloqueio erra para o lado seguro: uma rota de
 * leitura com verbo de escrita no nome (ex.: GerarPlanilha) tambem fica bloqueada nesse modo.
 */

// Verbos de gravacao em FORMA EXATA (Salvar/Salva, Cria/Criar, Fechar/Fecha...), conferidos em
// TODAS as palavras do nome da rota (TISalvaPermissao, AppCriarEstacao, NotificaPorTag). Forma
// exata, e nao radical, porque o radical pega substantivo de rota de LEITURA: Lancamentos,
// Publico, Vinculo, Importacao, Pago, Marcadores, Enviados, Movimentacoes, Geral...
const VERBOS = new RegExp('^(?:' + [
    'salv(?:ar|a|e)', 'apag(?:ar|a|ue)', 'exclu(?:ir|i|a)', 'remov(?:er|e|a)', 'grav(?:ar|a|e)',
    'atualiz(?:ar|a|e)', 'aprov(?:ar|a|e)', 'recus(?:ar|a|e)', 'finaliz(?:ar|a|e)', 'import(?:ar|a|e)',
    'alter(?:ar|a|e)', 'defin(?:ir|e|a)', 'lanc(?:ar|a|e)', 'cadastr(?:ar|a|e)', 'inser(?:ir|e|a)',
    'delet(?:ar|a|e)', 'upload', 'sincroniz(?:ar|a|e)', 'duplic(?:ar|a|e)', 'bloque(?:ar|ia|ie)',
    'desbloque(?:ar|ia)', 'ativ(?:ar|a)', 'desativ(?:ar|a)', 'reset(?:ar|a)?', 'atribu(?:ir|i|a)',
    'public(?:ar|a)', 'confirm(?:ar|a)', 'cancel(?:ar|a)', 'registr(?:ar|a)', 'execut(?:ar|a|e)',
    'dispar(?:ar|a)', 'agendar', 'aplic(?:ar|a)', 'restaur(?:ar|a)', 'renome(?:ar|ia)',
    'vincul(?:ar|a)', 'desvincul(?:ar|a)', 'envi(?:ar|a|e)', 'cri(?:ar|a|e)', 'troc(?:ar|a)',
    'mud(?:ar|a)', 'ger(?:ar|a)', 'fix(?:ar|a)', 'marc(?:ar|a)', 'mov(?:er|e)', 'neg(?:ar|a)',
    'liber(?:ar|a)', 'copi(?:ar|a)', 'pag(?:ar|a)', 'edit(?:ar|a)', 'sub(?:ir|a)', 'anul(?:ar|a)',
    'armazen(?:ar|a)', 'assin(?:ar|a)', 'congel(?:ar|a)', 'compartilh(?:ar|a)', 'complet(?:ar|a)',
    'conclu(?:ir|i)', 'consolid(?:ar|a)', 'descart(?:ar|a)', 'encerr(?:ar|a)', 'solicit(?:ar|a)',
    'toggle', 'fech(?:ar|a)', 'notific(?:ar|a)', 'orden(?:ar|a)', 'parar', 'promov(?:er|e)',
    'proteg(?:er|e)', 'reabr(?:ir|e)', 'receb(?:er|e)', 'recompor', 'resolv(?:er|e)', 'revert(?:er|e)',
    'propor', 'ajust(?:ar|a)', 'entrar', 'ok', 'limp(?:ar|a)', 'arquiv(?:ar|a)', 'reprocess(?:ar|a)',
    'transfer(?:ir|e)', 'desconect(?:ar|a)',
].join('|') + ')$');

function palavras(seg) {
    return (String(seg || '').match(/[A-Z]+(?![a-z])|[A-Z]?[a-z0-9]+/g) || []).map((w) => w.toLowerCase());
}

// Rotas que GRAVAM sem verbo no nome (medido no codigo em 01/10/2026: INSERT/UPDATE no handler).
const SEMPRE_GRAVAM = ['BalancoEstoque/AppScan', 'CrmLeads/Converter', 'CaixaLoja/Observacao', 'RotinaPosLancamento/Trocas'];
// Rotas que leem OU gravam conforme o corpo: { salvar }, { criar }, { texto }...
const CORPO_GRAVA = ['salvar', 'criar', 'gravar', 'excluir', 'apagar'];
const CORPO_POR_ROTA = { 'FichaParceiros/ObsConfidencial': 'texto' };

function corpoDe(body) {
    if (!body || typeof body !== 'string') return null;
    try { const j = JSON.parse(body); return (j && typeof j === 'object') ? j : null; } catch (_) { return null; }
}

export function ehGravacao(url, metodo, body) {
    const m = String(metodo || 'GET').toUpperCase();
    if (m === 'PUT' || m === 'DELETE' || m === 'PATCH') return true;
    if (m === 'GET' || m === 'HEAD') return false;
    let p = '';
    try { p = new URL(url, window.location.href).pathname; } catch (_) { p = String(url || ''); }
    const partes = p.split('/').filter(Boolean);
    const seg = partes[partes.length - 1] || '';
    const modRota = partes.slice(-2).join('/');
    if (palavras(seg).some((w) => VERBOS.test(w))) return true;
    if (SEMPRE_GRAVAM.some((r) => r.toLowerCase() === modRota.toLowerCase())) return true;
    const j = corpoDe(body);
    if (j) {
        if (CORPO_GRAVA.some((k) => j[k])) return true;
        const k = Object.keys(CORPO_POR_ROTA).find((r) => r.toLowerCase() === modRota.toLowerCase());
        if (k && j[CORPO_POR_ROTA[k]]) return true;
    }
    return false;
}

export const MSG_BLOQUEIO = 'Modo "ver como": ações que gravam estão bloqueadas. Volte para a sua conta para alterar algo.';

let original = null;
export function instalaGuarda(ativo) {
    if (typeof window === 'undefined' || typeof window.fetch !== 'function') return;
    if (ativo && !original) {
        original = window.fetch.bind(window);
        window.fetch = (input, init) => {
            const url = typeof input === 'string' ? input : ((input && input.url) || '');
            const metodo = (init && init.method) || (input && input.method) || 'GET';
            if (ehGravacao(url, metodo, init && init.body)) {
                return Promise.resolve(new Response(JSON.stringify({ Error: MSG_BLOQUEIO, verComo: true }),
                    { status: 200, headers: { 'Content-Type': 'application/json' } }));
            }
            return original(input, init);
        };
    } else if (!ativo && original) {
        window.fetch = original;
        original = null;
    }
}

export function podeVerComo(u) {
    return !!u && !u.verComo && (u.setor === 'TI' || u.cargo === 'Administrador');
}

// O usuario de sessao do alvo, no MESMO formato que o login (ConsultaUsuario) devolve.
// must_change desligado (nao jogar a TI na troca de senha do outro) e samba vazio (nao
// emprestar as credenciais de rede da TI para a tela de Arquivos do outro).
export function sessaoDe(alvo, real) {
    return {
        id: alvo.id, nome: alvo.nome, email: alvo.email, login: alvo.login,
        setor: alvo.setor, cargo: alvo.cargo,
        codigo_vendedora: alvo.codigo_vendedora, loja: alvo.loja,
        vinculo_fornecedor: alvo.vinculo_fornecedor, fornecedor_nome: alvo.fornecedor_nome,
        must_change: false,
        restrito: !!alvo.restrito,
        samba: { dominio: 'BABITA', usuario: `babita\\${alvo.login || ''}`, configurado: false, servidores: [] },
        verComo: { nome: real.nome, email: real.email },
    };
}
